// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "items-dzUrL";
var _4 = "passenger-3yQyb";
var _5 = "baggage__passenger-2Ww83";
export { _1 as "__esModule", _2 as "mobile", _3 as "items", _4 as "passenger", _5 as "baggage__passenger" }
export default { "__esModule": _1, "mobile": _2, "items": _3, "passenger": _4, "baggage__passenger": _5 }
